import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class Payment extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "payment";
    static pluralName = "payments";
    static displayName = "Payment";

    constructor() {
        super(Payment.kind, Payment.singularName, Payment.pluralName);
    }

    async getAll(query = {}) {
        return this.fetch(qs.stringify(query, {encodeValuesOnly: true}));
    }

    async getById(id, query = {}) {
        return this.find(id, {populate: "*", ...query});
    }

    async requestZarinpal(paymentDocumentId) {
        return this.postAction("/payments/zarinpal/request", {paymentDocumentId});
    }

    async requestZarinpalForInvoice(invoiceDocumentId) {
        return this.postAction("/payments/zarinpal/request", {invoiceDocumentId});
    }

    async getZarinpalStatus(authority, workspaceDocumentId) {
        return this.action("", `/payments/zarinpal/status/${encodeURIComponent(authority)}`, workspaceDocumentId);
    }
}
